<template>
  <div class="minhaconta">
    <div class="container minhaconta">
      <input type="hidden" name="_token" :value="token" />
      <h4 class="ui-title f-32">Minha conta</h4>
      <p class="f-20">Aqui tem todas as informações do seu perfil.</p>
      <div class="bloco-input" :class="errors.name ? 'ui-invalid-bloco' : ''">
        <label class="ui-label">Nome</label>
        <input
          class="ui-input"
          type="text"
          name="name"
          v-model="form.name"
          required
        />
        <label>{{ errors.name }}</label>
      </div>
      <div class="bloco-input" :class="errors.email ? 'ui-invalid-bloco' : ''">
        <label class="ui-label">E-mail</label>
        <input
          class="ui-input"
          type="email"
          name="email"
          v-model="form.email"
          readonly
        />
        <label>{{ errors.email }}</label>
      </div>
      <div class="bloco-input" :class="errors.phone ? 'ui-invalid-bloco' : ''">
        <label class="ui-label" id="tel">Telefone</label>
        <the-mask
          class="ui-input input"
          type="text"
          :masked="true"
          name="phone"
          v-model="form.phone"
          :mask="['(##) #####-####', '(##) ####-####']"
          required
        ></the-mask>
        <label>{{ errors.phone }}</label>
      </div>
      <div class="bloco-input" :class="errors.cpf ? 'ui-invalid-bloco' : ''">
        <label class="ui-label" id="cpf">CPF</label>
        <the-mask
          class="ui-input input"
          type="text"
          :masked="true"
          :mask="['###.###.###-##']"
          name="cpf"
          v-model="form.cpf"
          readonly
        ></the-mask>
        <label>{{ errors.cpf }}</label>
      </div>
      <!-- <div
        class="bloco-input"
        :class="errors.birthday ? 'ui-invalid-bloco' : ''"
      >
        <label class="ui-label">Data de nascimento</label>
        <the-mask
          class="ui-input input"
          type="text"
          v-model="form.birthday"
          :masked="true"
          :mask="['##/##/####']"
          required
        />
        <label>{{ errors.birthday }}</label>
      </div> -->
      <!-- <div class="bloco-input" :class="errors.cep ? 'ui-invalid-bloco' : ''">
        <label class="ui-label" id="cep">CEP</label>
        <the-mask
          class="ui-input input"
          type="text"
          :masked="true"
          name="cep"
          v-model="form.cep"
          :mask="['#####-###']"
          required
        ></the-mask>
        <label>{{ errors.cep }}</label>
      </div> -->
      <!-- <div class="bloco-input" :class="errors.street ? 'ui-invalid-bloco' : ''">
        <label class="ui-label">Rua</label>
        <input
          class="ui-input"
          type="text"
          required
          name="street"
          v-model="form.street"
        />
        <label>{{ errors.street }}</label>
      </div> -->
      <!-- <div
        class="bloco-input"
        :class="errors.district ? 'ui-invalid-bloco' : ''"
      >
        <label class="ui-label">Bairro</label>
        <input
          class="ui-input"
          type="text"
          required
          name="district"
          v-model="form.district"
        />
        <label>{{ errors.district }}</label>
      </div> -->
      <!-- <div class="bloco-input" :class="errors.number ? 'ui-invalid-bloco' : ''">
        <label class="ui-label">Número</label>
        <input
          class="ui-input"
          type="number"
          name="number"
          v-model="form.number"
        />
        <label>{{ errors.number }}</label>
      </div> -->
      <!-- <div
        class="bloco-input"
        :class="errors.complement ? 'ui-invalid-bloco' : ''"
      >
        <label class="ui-label">Complemento</label>
        <input
          class="ui-input"
          type="text"
          name="complement"
          v-model="form.complement"
        />
        <label>{{ errors.complement }}</label>
      </div> -->
      <div class="bloco-input" :class="errors.state ? 'ui-invalid-bloco' : ''">
        <label class="ui-label">Estado</label>
        <select
          class="ui-input input"
          required
          v-model="model_state"
          id="state"
          name="state"
        >
          <option
            v-for="(option, index) in select_state"
            :key="index"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
        <label>{{ errors.state }}</label>
      </div>
      <div class="bloco-input" :class="errors.city ? 'ui-invalid-bloco' : ''">
        <label class="ui-label">Cidade</label>
        <select
          class="ui-input input"
          required
          v-model="model_city"
          id="city"
          name="city"
        >
          <option
            v-for="(option, index) in select_cities"
            :key="index"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
        <label>{{ errors.city }}</label>
      </div>
      <button
        @click.prevent="sendCad()"
        type="button"
        class="ui-button-green"
        :disabled="btnCad.disabled"
        v-html="btnCad.text"
      ></button>

      <h4 class="ui-title f-32" style="margin-top: 30px">Atualizar senha</h4>
      <div
        class="bloco-input"
        :class="errors.old_password ? 'ui-invalid-bloco' : ''"
      >
        <label class="ui-label">Senha atual</label>
        <input
          v-model="form_pass.old_password"
          class="ui-input"
          type="password"
          required
          id="password_conta3"
        />
        <i
          class="fa fa-eye-slash icon_conta eyes"
          aria-hidden="true"
          id="eyes_conta3"
          onclick="minhaconta3()"
        ></i>
        <label>{{ errors.old_password }}</label>
      </div>
      <div
        class="bloco-input"
        :class="errors.new_password ? 'ui-invalid-bloco' : ''"
      >
        <label class="ui-label">Nova senha</label>
        <input
          v-model="form_pass.new_password"
          class="ui-input"
          type="password"
          id="password_conta1"
          required
        />
        <i
          class="fa fa-eye-slash icon_conta eyes"
          aria-hidden="true"
          id="eyes_conta1"
          onclick="minhaconta1()"
        ></i>
        <label>{{ errors.new_password }}</label>
      </div>
      <div
        class="bloco-input"
        :class="errors.confirm_password ? 'ui-invalid-bloco' : ''"
      >
        <label class="ui-label">Confirmar senha</label>
        <input
          v-model="form_pass.confirm_password"
          class="ui-input"
          type="password"
          required
          id="password_conta2"
        />
        <i
          class="fa fa-eye-slash icon_conta eyes"
          aria-hidden="true"
          id="eyes_conta2"
          onclick="minhaconta2()"
        ></i>
        <label>{{ errors.confirm_password }}</label>
      </div>
      <button
        @click.prevent="sendPass()"
        class="ui-button-green"
        :disabled="btnPass.disabled"
        v-html="btnPass.text"
      ></button>
      <a href="/logout">
        <button class="ui-button-yellow">Sair</button>
      </a>
    </div>
  </div>
</template>
<script>
import brazil from "/public/cities/cidades.json";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  props: ["city", "state", "client", "token"],
  components: {
    DatePicker,
  },
  data() {
    return {
      select_cities: [],
      select_state: [],
      model_state: "",
      model_city: "",
      form: {
        name: "",
        email: "",
        phone: "",
        cpf: "",
        // birthday: "",
        // cep: "",
        // street: "",
        // district: "",
        // number: "",
        // complement: "",
        state: "",
        city: "",
      },
      form_pass: {
        old_password: "",
        new_password: "",
        confirm_password: "",
      },
      btnCad: {
        text: "<i>Atualizar</i>",
        disabled: false,
      },
      btnPass: {
        text: "<i>Atualizar senha</i>",
        disabled: false,
      },
      errors: {},
    };
  },
  created() {
    if (this.city) {
      this.model_city = this.city;
    }
    if (this.state) {
      this.model_state = this.state;
    }
    for (var city of brazil.estados) {
      this.select_state.push({
        value: city.sigla,
        label: city.nome,
      });
    }
    var client = JSON.parse(this.client);
    this.form = {
      name: client.name,
      email: client.email,
      phone: client.phone,
      cpf: client.cpf,
      // birthday: client.birthday,
      // cep: client.cep,
      // street: client.street,
      // district: client.district,
      // number: client.number,
      // complement: client.complement,
    };
    this.model_state = client.state;
    this.model_city = client.city;
  },
  watch: {
    "form.cep"() {
      this.ViaCep();
    },
    model_state() {
      this.select_cities = brazil.estados.filter((estado) => {
        if (estado.sigla == this.model_state) {
          return estado.cidades;
        }
      });
      if (this.select_cities[0]) {
        for (var city of this.select_cities[0].cidades) {
          this.select_cities.push({
            value: city,
            label: city,
          });
        }
      }
    },
  },
  methods: {
    ViaCep: function () {
      if (this.form.cep) {
        if (this.form.cep.length == 9) {
          axios.get("viacep/" + this.form.cep).then((response) => {
            if (response.data.erro) {
              this.$swal("Oops!", "CEP Inválido!", "error");
              this.cep = "";
            } else {
              this.model_state = response.data.uf;
              this.model_city = response.data.localidade;
              this.form.street = response.data.logradouro;
              this.form.district = response.data.bairro;
            }
          });
        }
      }
    },
    sendCad: async function () {
      this.btnCad = {
        text: '<i class="fa fa-spinner fa-pulse"></i>',
        disabled: true,
      };
      var data = this.form;
      data.state = this.model_state;
      data.city = this.model_city;
      await axios
        .post("/minhaconta-update", data)
        .then((res) => {
          if (res.data.errors) {
            var errors = res.data.errors;
            var errorsKeys = Object.keys(errors);
            for (let i = 0; i < errorsKeys.length; i++) {
              const key = errorsKeys[i];
              this.errors[key] = errors[key][0];
            }
          } else {
            this.$swal({
              title: res.data,
              type: "success",
            });
            this.errors = {};
          }
        })
        .catch((e) => {
          this.$swal({
            title: "Ops, ocorreu um erro ao cadastrar sua conta",
            text: "Contate o nosso suporte ou tente novamente mais tarde",
            type: "error",
          });
        });
      this.btnCad = {
        text: "<i>Atualizar</i>",
        disabled: false,
      };
    },
    sendPass: async function () {
      this.btnPass = {
        text: '<i class="fa fa-spinner fa-pulse"></i>',
        disabled: true,
      };
      await axios
        .post("/password", this.form_pass)
        .then((res) => {
          if (res.data.errors) {
            var errors = res.data.errors;
            var errorsKeys = Object.keys(errors);
            for (let i = 0; i < errorsKeys.length; i++) {
              const key = errorsKeys[i];
              this.errors[key] = errors[key][0];
            }
          } else {
            this.$swal({
              title: res.data,
              type: "success",
            });
            this.errors = {};
            this.form_pass = {
              old_password: "",
              new_password: "",
              confirm_password: "",
            };
          }
        })
        .catch((e) => {
          this.$swal({
            title: e.response.data,
            type: "error",
          });
          this.errors = {};
          this.form_pass = {
            old_password: "",
            new_password: "",
            confirm_password: "",
          };
        });
      this.btnPass = {
        text: "<i>Atualizar</i>",
        disabled: false,
      };
    },
  },
};
</script>
